import { render, staticRenderFns } from "./AgencyTalents.vue?vue&type=template&id=7c876c89"
import script from "./AgencyTalents.vue?vue&type=script&lang=js"
export * from "./AgencyTalents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports